import React, { useState, useEffect, useCallback, useRef } from 'react';
import { fetchGoqiiCashTransactions } from '../apiservices/ApiService';


// --- SVG Icons ---
// --- SVG Icons ---
const GoqiiCoinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#facc15" />
    <text
      x="12"
      y="16"
      fontSize="14"
      fontWeight="bold"
      textAnchor="middle"
      fill="#ca8a04"
    >
      G
    </text>
  </svg>
);

const StepsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <path
      d="M12 2a5 5 0 0 0-5 5c0 1.44.63 2.73 1.61 3.62L5 14.16V16h1.5l2.06-2.06a4.93 4.93 0 0 0 2.88 0L13.5 16H15v-1.84l-3.61-3.54A4.93 4.93 0 0 0 17 7a5 5 0 0 0-5-5zm-3.5 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm7 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
      fill="#f97316"
    />
  </svg>
);

const HabitIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      fill="#3b82f6"
    />
  </svg>
);
const StoreOfferIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#f0abfc" />
    <path
      d="M7 7h10v2H7V7zm0 4h10v2H7v-2zm0 4h6v2H7v-2z"
      fill="#a21caf"
    />
    <text
      x="17"
      y="18"
      fontSize="10"
      fontWeight="bold"
      textAnchor="middle"
      fill="#a21caf"
    >
      %
    </text>
  </svg>
);

const HealthStoreOrderIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#bbf7d0" />
    <path
      d="M7 7h10l1 12H6L7 7z"
      fill="#22c55e"
    />
    <path
      d="M12 10v4m-2-2h4"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const ActivityIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#bfdbfe" />
    <path
      d="M9 12l2-2 4 4 2-2"
      fill="none"
      stroke="#1d4ed8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 16h10"
      stroke="#1d4ed8"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const FoodIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#fca5a5" />
    <path
      d="M12 7c-2.5 0-4.5 2-4.5 4.5S9.5 16 12 16s4.5-2 4.5-4.5S14.5 7 12 7z"
      fill="#dc2626"
    />
    <path
      d="M12 7V5m0 0l-1 1m1-1l1 1"
      stroke="#b91c1c"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);


const DrinkWaterIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#bae6fd" />
    <path
      d="M12 7c-2 3-4 4-4 6a4 4 0 0 0 8 0c0-2-2-3-4-6z"
      fill="#0ea5e9"
    />
    <path
      d="M12 7V5"
      stroke="#0284c7"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const HumanWeighingScaleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#bbf7d0" />
    <circle cx="12" cy="8" r="2" fill="#065f46" />
    <path d="M12 10v4" stroke="#047857" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 14l2 3 2-3" stroke="#047857" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="8" y="17" width="8" height="2" rx="1" fill="#4ade80" />
  </svg>
);

const SleepIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    {/* Background circle */}
    <circle cx="12" cy="12" r="10" fill="#c7d2fe" />
    {/* Crescent moon */}
    <path
      d="M15 12a5 5 0 1 1-5-5 3.5 3.5 0 0 0 5 5z"
      fill="#4f46e5"
    />
    {/* Zzz lines */}
    <text x="12" y="18" fontSize="6" fontWeight="bold" textAnchor="middle" fill="#312e81">
      Z
    </text>
  </svg>
);
const DoctorIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    {/* Background circle */}
    <circle cx="12" cy="12" r="10" fill="#a7f3d0" />
    {/* Head */}
    <circle cx="12" cy="8" r="2" fill="#065f46" />
    {/* Body (white coat) */}
    <path
      d="M10 10h4v5h-4z"
      fill="#ffffff"
      stroke="#065f46"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Stethoscope */}
    <path
      d="M11 15c0 1-1 1-1 2s1 1 2 1 2 0 2-1-1-1-1-2"
      stroke="#10b981"
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

const PlayIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    {/* Background circle */}
    <circle cx="12" cy="12" r="10" fill="#bfdbfe" />
    {/* Play triangle */}
    <polygon
      points="10,8 16,12 10,16"
      fill="#1d4ed8"
    />
  </svg>
);

const TransactionIcon = ({ type }) => {
  const iconStyle = {
    width: 40,
    height: 40,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const t = String(type).toLowerCase();

  if (t.includes('bonus')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#fef3c7' }}>
        <GoqiiCoinIcon />
      </div>
    );
  }

  if (t.includes('steps')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#ffedd5' }}>
        <StepsIcon />
      </div>
    );
  }

  if (t.includes('habit')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <HabitIcon />
      </div>
    );
  }

  if (t.includes('used')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#fee2e2' }}>
        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>G</span>
      </div>
    );
  }

    
  if (t.includes('storeoffer')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <StoreOfferIcon />
      </div>
    );
  }

  if (t.includes('storeorder')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <HealthStoreOrderIcon />
      </div>
    );
  }

  if (t.includes('activity')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <ActivityIcon />
      </div>
    );
  }

  if (t.includes('food')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <FoodIcon />
      </div>
    );
  }

  if (t.includes('water')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <DrinkWaterIcon />
      </div>
    );
  }

  if (t.includes('weight')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <HumanWeighingScaleIcon />
      </div>
    );
  }

  if (t.includes('sleep')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <SleepIcon />
      </div>
    );
  }

  if (t.includes('doc')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <DoctorIcon />
      </div>
    );
  }

  if (t.includes('play')) {
    return (
      <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
        <PlayIcon />
      </div>
    );
  }

  return <div style={{ ...iconStyle, backgroundColor: '#e5e7eb' }} />;
};


// --- Main Screen Component ---
const GoqiiCashStatement = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [activeTab, setActiveTab] = useState('all');
  const [totalPoints, setTotalPoints] = useState("");
  const [expiresLine1, setExpiresLine1] = useState("");
  const [expiresLine2, setExpiresLine2] = useState("");
  const listRef = useRef(null);

  const loadTransactions = useCallback(async (page, tab) => {
    if (loading || !hasMore) return;
    setLoading(true);
    try {
      const response = await fetchGoqiiCashTransactions({
        pagination: page,
        // 'all', 'earned', 'used'
        paginationFor: tab === "all"?"alltabspagination":tab === "earned"?"earnedtabpagination":"burnedtabpagination"
      });
      
      if (response) {
        console.log(JSON.stringify(response))
        const newTransactions = response.ledger || [];
        setTotalPoints(response.totalRewardPoints);
        setExpiresLine1(response.expiresLine1);
        setExpiresLine2(response.expiresLine2);
        if (newTransactions.length > 0) {
          setTransactions(prev => page === 0 ? newTransactions : [...prev, ...newTransactions]);
          setPage(response.pagination);
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error('Error loading transactions:', error);
      setHasMore(false);
    }
    setLoading(false);
  }, [loading, hasMore]);

  useEffect(() => {
    setTransactions([]);
    setPage(1);
    setHasMore(true);
    setTimeout(() => {
        loadTransactions(1, activeTab);
    }, 0);
  }, [activeTab]);

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = listRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      loadTransactions(page, activeTab);
    }
  };

  const handleTabPress = (tab) => {
    setPage(0);
    setActiveTab(tab);
  };
  
  // --- Inline Styles ---
  const styles = {
    body: {
      backgroundColor: '#E2E8F0',
      fontFamily: 'sans-serif',
    },
    container: {
      height: '100vh',
      width: '100%',
      maxWidth: '448px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#F8FAFC',
      boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
    },
    header: {
      position: 'relative',
      textAlign: 'center',
      padding: '20px',
      paddingTop: '32px',
      background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2) 100%)",
    },
    headerTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#854d0e',
      letterSpacing: '0.05em',
    },
    balanceContainer: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#bef264',
      padding: '8px 20px',
      borderRadius: '9999px',
      border: '2px solid #facc15',
      boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)',
      margin: '8px 0',
    },
    balanceText: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#4d7c0f',
      marginLeft: '8px',
    },
    expiryText: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#dc2626',
    },
    tabsContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '12px',
      backgroundColor: 'rgba(240, 249, 255, 0.5)',
      borderBottom: '1px solid #e0f2fe',
    },
    tabButton: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px',
      borderRadius: '9999px',
      margin: '0 6px',
      transition: 'background-color 0.3s',
      border: 'none',
      cursor: 'pointer',
    },
    listHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '16px',
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e5e7eb',
    },
    listHeaderText: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#4b5563',
    },
    scrollableList: {
      flex: 1,
      overflowY: 'auto',
    },
    itemContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: '16px',
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #f3f4f6',
    },
    itemDetails: {
      flex: 1,
      marginLeft: '16px',
    },
    itemTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#1f2937',
    },
    itemDate: {
      fontSize: '12px',
      color: '#6b7280',
      marginTop: '4px',
    },
    itemAmountContainer: {
      textAlign: 'right',
    },
    itemAmount: {
      fontSize: '16px',
      fontWeight: 'bold',
    },
    itemExpiry: {
      fontSize: '12px',
      color: '#ef4444',
      marginTop: '4px',
    },
    loader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px',
    }
  };

  const renderItem = (item) => (
    <div key={item.id} style={styles.itemContainer}>
      <TransactionIcon type={item.eventKeyword} />
      <div style={styles.itemDetails}>
        <p style={styles.itemTitle}>{item.eventTitle}</p>
        <p style={styles.itemDate}>{item.date}</p>
      </div>
      <div style={styles.itemAmountContainer}>
       <p
  style={{
    ...styles.itemAmount,
    color: String(item.rewardPoints).includes('+') ? '#16a34a' : '#dc2626',
  }}
>
  {item.rewardPoints}
</p>
        <p style={styles.itemExpiry}>{item.expiresOn}</p>
      </div>
    </div>
  );

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.headerTitle}>GOQII CASH BALANCE</h1>
          <div style={styles.balanceContainer}>
            <GoqiiCoinIcon />
            <span style={styles.balanceText}>{totalPoints}</span>
          </div>
          <p style={styles.expiryText}>{expiresLine1} {expiresLine2}</p>
        </div>

        <div style={styles.tabsContainer}>
          {['all', 'earned', 'used'].map(tab => (
            <button key={tab} onClick={() => handleTabPress(tab)} style={{...styles.tabButton, backgroundColor: activeTab === tab ? '#2563eb' : '#bae6fd', color: activeTab === tab ? '#ffffff' : '#0369a1'}}>
              {tab !== 'all' && <span style={{marginRight: '6px'}}>{tab === 'earned' ? '💰' : '💸'}</span>}
              <span style={{fontSize: '14px', fontWeight: 'bold'}}>{tab.toUpperCase()}</span>
            </button>
          ))}
        </div>
        
        <div style={styles.listHeader}>
            <p style={styles.listHeaderText}>Top Activities</p>
            <p style={styles.listHeaderText}>GOQII Cash</p>
        </div>

        <div ref={listRef} onScroll={handleScroll} style={styles.scrollableList}>
          {transactions.map(item => renderItem(item))}
          {loading && (
            <div style={styles.loader}>
              <div style={{animation: 'spin 1s linear infinite', borderRadius: '50%', width: '32px', height: '32px', border: '4px solid rgba(0,0,0,0.1)', borderTopColor: '#f97316'}}></div>
              <style>{`
                @keyframes spin {
                  to { transform: rotate(360deg); }
                }
              `}</style>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoqiiCashStatement;
